<template>
    <div>
        <h4>{{ title || 'Location' }}</h4>

        <l-map
            :zoom="zoom"
            :center="location.center"
            :max-bounds="maxBounds"
            ref="map"
            style="height: 400px"
        >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-marker
                :lat-lng="location.center"
                :draggable="true"
                @moveend="setMarkerPos"
                ref="marker"
            >
            </l-marker>
            <l-control class="map-custom-control">
                <div class="float-right">
                    <button
                        type="button"
                        class="btn btn-success btn-sm"
                        @click="centerLocation"
                    >
                        Center Location
                    </button>
                </div>
            </l-control>
        </l-map>
    </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LControl } from 'vue2-leaflet'

import MapBounds from '@/mixins/mapBounds.js'
const L = window.L

export default {
    name: 'location-picker',
    mixins: [MapBounds],
    components: { LMap, LTileLayer, LMarker, LControl },
    props: {
        location: {
            type: Object,
        },
        title: {
            type: String,
        },
    },
    data() {
        return {
            zoom: 13,
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

            //query: '',
        }
    },

    mounted() {
        const map = this.$refs.map.mapObject
        map.addControl(new L.Control.Fullscreen())
    },
    methods: {
        setMarkerPos() {
            this.$emit('set-location', this.$refs.marker.mapObject.getLatLng())
        },
        centerLocation() {
            this.$refs.map.mapObject.setView(this.location.center, this.zoom)
        },
    },
}
</script>

<style>
.autocomplete input {
    border-radius: 0;
}

#map.fullscreen {
    z-index: 9999;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

#map {
    height: 418px;
}

.map-custom-control {
    background: #fff;
    padding: 0 0.5em;
    border: 1px solid #aaa;
    border-radius: 0.1em;
}
</style>
